import React from 'react';

class ContactPage extends React.Component {
  constructor() {
    super();
    this.state = { sendMessage: null, msgClass: '' };
    this.submitForm = this.submitForm.bind(this);
  }

  submitForm(event) {
    event.preventDefault();
    const inputs = event.target.getElementsByTagName('input');
    const message = event.target.getElementsByTagName('textarea').message.value;
    fetch(atob('aHR0cHM6Ly9mb3Jtc3ByZWUuaW8vaGF0aW1AdWFsYmVydGEuY2E='), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: inputs.name.value,
        email: inputs.email.value,
        subject: inputs.subject.value,
        message
      })
    }).then(res => {
      if (res.ok) {
        this.setState({
          sendMessage: 'Your Message was Successfully received.',
          msgClass: 'success'
        });
      } else {
        this.setState({
          sendMessage: 'There was an error sending your message.',
          msgClass: 'error'
        });
      }
    });
  }

  render() {
    return (
      <div className="page-content">
        {this.state.sendMessage ? (
          <p className={this.state.msgClass}>{this.state.sendMessage}</p>
        ) : null}
        <form
          id="ContactForm"
          className="contactForm"
          onSubmit={this.submitForm}
        >
          <p>Your Name (required)</p>
          <i className="fa fa-user" />
          <input type="text" name="name" size="40" required />
          <p>Your E-mail (required)</p>
          <i className="fa fa-envelope" />
          <input type="email" name="email" size="40" required />
          <p>Subject</p>
          <i className="fa fa-question" />
          <input type="text" name="subject" size="40" />
          <p>Your Message</p>
          <i className="fa fa-comment-o" />
          <textarea name="message" cols="40" rows="10" defaultValue="" />
          <button type="submit" className="formSubmit">
            Send
          </button>
        </form>
      </div>
    );
  }
}

export default ContactPage;
